import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import urls from '../../../../../networkRequests/apiClient/endpoints'
import errorHandler from '../../../../../shared/functions/ErrorHandler/errorHandler.functions'
import { ApiErrorResponse } from '../../../../../shared/types/api.types'
import { cancelOfferRequestForAdminApi } from './cancelOfferRequestForAdmin.api'
import cancelOfferRequestForAdminInitialState from './cancelOfferRequestForAdmin.initialState'
import {
  CancelOfferRequestForAdminErrorResponse,
  CancelOfferRequestForAdminRequestPayload
} from './cancelOfferRequestForAdmin.types'

export const cancelOfferRequestForAdmin = createAsyncThunk(
  `${urls.admin.cancelOfferRequestForAdmin}`,
  async (payload: CancelOfferRequestForAdminRequestPayload, { rejectWithValue }) => {
    const { request, onSuccess } = payload

    try {
      const response = await cancelOfferRequestForAdminApi(request)

      onSuccess && onSuccess()

      return response
    } catch (error) {
      errorHandler.handleApiError(error as ApiErrorResponse)

      return rejectWithValue(error)
    }
  }
)

const cancelOfferRequestForAdminSlice = createSlice({
  name: urls.admin.cancelOfferRequestForAdmin,
  initialState: cancelOfferRequestForAdminInitialState,
  reducers: {
    resetCancelOfferRequestForAdmin: (state) => {
      state.loading = false
      state.error = null
      state.success = null
    }

    // Add any additional reducers here
  },
  extraReducers: (builder) => {
    builder
      .addCase(cancelOfferRequestForAdmin.pending, (state) => {
        state.loading = true
        state.error = null
        state.success = null
      })
      .addCase(cancelOfferRequestForAdmin.fulfilled, (state, { payload }) => {
        state.loading = false
        state.success = payload
        state.error = null
      })
      .addCase(cancelOfferRequestForAdmin.rejected, (state, { payload }) => {
        state.loading = false
        state.error = payload as CancelOfferRequestForAdminErrorResponse
        state.success = null
      })
  }
})

export const { actions: cancelOfferRequestForAdminActions, reducer: cancelOfferRequestForAdminReducer } =
  cancelOfferRequestForAdminSlice
export const { resetCancelOfferRequestForAdmin } = cancelOfferRequestForAdminActions
export default cancelOfferRequestForAdminSlice.reducer
